import React from "react";
import MultiDimensionDateColumnFilterPopup from "./MultiDimensionDateColumnFilterPopup";
import MultiDimensionNumberColumnFilterPopup from "./MultiDimensionNumberColumnFilterPopup";
import MultiDimensionTextColumnFilterPopup from "./MultiDimensionTextColumnFilterPopup";
import { normalizeMultiDimensionType } from "../workflowVariables.constants";

/**
 * Routes to the correct filter UI for the dimension data type (text | number | date).
 */
const MultiDimensionColumnFilterPopup = ({ dimension, anchorRef, savedComposite, onApply, onClear, onClose }) => {
  if (!dimension?.id) return null;

  const type = normalizeMultiDimensionType(dimension.type);
  /** Avoid new object identity each render when no saved filter (prevents draft reset). */
  const initialComposite = savedComposite != null ? savedComposite : null;

  const common = {
    dimension,
    anchorRef,
    initialComposite,
    onApply,
    onClear,
    onClose,
  };

  if (type === "number") {
    return <MultiDimensionNumberColumnFilterPopup {...common} />;
  }
  if (type === "date") {
    return <MultiDimensionDateColumnFilterPopup {...common} />;
  }
  return <MultiDimensionTextColumnFilterPopup {...common} />;
};

export default MultiDimensionColumnFilterPopup;
